import http from "@/axios/http-common";

async function setBatuk(rm: string | number): Promise<any> {
  const { data } = await http
    .postData(`/pasien/${rm}/tag`, {
      name: "batuk-2mg"
    })
    .catch(err => {
      return Promise.reject(err);
    });

  return data;
}

async function removeBatuk(rm: string | number): Promise<any> {
  const { data } = await http
    .deleteData(`/pasien/${rm}/tag/batuk-2mg`)
    .catch(err => {
      return Promise.reject(err);
    });

  return data;
}

async function setRegHF(rm: string | number): Promise<any> {
  const { data } = await http
    .postData(`/pasien/${rm}/tag`, {
      name: "reg-heart-failure"
    })
    .catch(err => {
      return Promise.reject(err);
    });

  return data;
}

async function removeRegHF(rm: string | number): Promise<any> {
  const { data } = await http
    .deleteData(`/pasien/${rm}/tag/reg-heart-failure`)
    .catch(err => {
      return Promise.reject(err);
    });

  return data;
}

async function setTag(rm: string | number, tag: string): Promise<any> {
  const { data } = await http
    .postData(`/pasien/${rm}/tag`, {
      name: tag
    })
    .catch(err => {
      return Promise.reject(err);
    });

  return data;
}

async function removeTag(rm: string | number, tag: string): Promise<any> {
  const { data } = await http
    .deleteData(`/pasien/${rm}/tag/${tag}`)
    .catch(err => {
      return Promise.reject(err);
    });

  return data;
}

export default {
  setBatuk,
  removeBatuk,
  setRegHF,
  removeRegHF,
  setTag,
  removeTag
};
